module.exports = __webpack_public_path__ + "static/media/realheader.8894e5bf.jpg";